/* istanbul ignore file */
export const ALEXA = "alexa";
export const AOG = "actions-on-google";
export const DIALOGFLOW = "dialogflow";
export const CHAT_WIDGET = "chat-widget";
export const LEX_CONNECT = "lex-connect";
export const LEX_V2 = "lex-v2";
export const INTELLIGENT_SEARCH = "intelligent-search";
export const GOOGLE_BUSINESS_MESSAGES = "google-business-messages";
export const FORM_WIDGET = "form-widget"

export type ChannelTypeName = "ActionsOnGoogleAppChannel" | "AlexaAppChannel" | "DialogflowAppChannel" | "ChatWidgetChannel" | "IntelligentSearchChannel" | "GoogleBusinessMessagesAppChannel" | "FormWidgetChannel";
